import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ProjectService } from "../services/projectservice.service";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  FormGroup,
  FormBuilder,
} from "@angular/forms";
import { CustomSearchService } from "src/app/services/custom-search.service";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { Location } from "@angular/common";
import { HeaderComponent } from "src/app/components/header/header.component";
declare var $: any;
import bsCustomFileInput from "bs-custom-file-input";
import { SearchPageService } from "../../searchpage/searchpage.service";
import { UserRoles } from "src/app/enums/userRoles.enum";
import { CommentsDialogComponent } from "src/app/components/comments-dialog/comments-dialog.component";
import { ProjectInformationHistory } from "src/app/Models/projectInformationHistory.model";
import { Notes } from "src/app/Models/notes.model";
import { ProjectType } from "src/app/enums/projectType.enum";
import { InfoDialogComponent } from "src/app/components/info-dialog/info-dialog.component";
import { ProjectInformation, projectNamesModel } from "src/app/Models/projectInformation.model";
import { ViewfileComponent } from "src/app/components/viewfile/viewfile.component";
import { AttachmentsModel } from "src/app/Models/attachments.model";
import { OrganizationService } from "src/app/services/Organization/organization.service";
import { AuthServiceService } from "src/app/services/auth-service.service";
import { EmployeeService } from "../../employee-profile/employee-profile.service";
import { SharedSkillService } from "../../skill-repository/shared-skill.service";
import { Observable } from 'rxjs';
import { ToastrService } from "ngx-toastr";

export class UploadFileResponse {
  savedBussinessCasePPTPath: string;
  savedCaseStudyPPTPath: string;
  savedLogoPath: string;
  savedICTPPTPath: string;
}

export enum AttachmentTypes {
  bussinessCaseStudy = 1,
  caseStudy = 2,
  clientLogo = 3,
  ppt = 4,
}

@Component({
  selector: "app-project-detail",
  templateUrl: "./project-detail.component.html",
  styleUrls: ["./project-detail.component.css"],
})
export class ProjectDetailComponent implements OnInit {
  public statuses = ["Active", "Inactive"];
  public projectTypeOptions = ["Fixed Bid", "Time and Material", "NA"];

  public deliveryOrganizations: any;

  public signedinUserOrgId = this.auth.getOrganizationId();

  public contentTypes = ["Case Studies"];

  public verticalOptions = [
    "Airlines & Aviation",
    "Automobile",
    "BFSI",
    "Biotechnology",
    "Consulting",
    "E-Commerce",
    "Education",
    "Energy & Utilities",
    "Engineering",
    "Healthcare",
    "Human Resources",
    "Information Technology",
    "International Trade & Development",
    "Legal",
    "Logistics & Transportation",
    "Manufacturing",
    "Media & Entertainment",
    "Non-profit Organization",
    "Retail",
    "Sales & Marketing",
    "Telecom",
    "Travel & Hospitality",
  ];
  public deliveryModelOptions = ["Waterfall", "Agile"];

  public loading = false;

  public attachmentTypes = AttachmentTypes;
  public searchTerm: string;
  public logoName = new UntypedFormControl("");
  public selectedLogoFileName: string;

  public uploads: Array<AttachmentsModel>;
  public formData: UntypedFormGroup;
  public title: string;
  public isViewData: boolean;
  private mainUrl = environment.mainUrl;

  public base64textString: string;
  @ViewChild(HeaderComponent) header: HeaderComponent;

  public selectedLogoFile: File = null;

  data: any;
  projectId: any;
  viewType: any;
  projectDetails: ProjectInformationHistory;
  isView: boolean;
  filteredValues: any[] = [];
  filteredValue: any[] = [];
  formsData: FormGroup;
  filteredProjectNames: Observable<projectNamesModel[]>;
  projectnames: Array<projectNamesModel> = [];
  storeProjectName: string;
  employee: any = {};
  a: any = null;
  mode: string;
  isProjectManger:boolean;
  users: any;
  flag: any;
  isPending = false;
  projectDeliveryOrgID: string;
  notes: { description: string; createdBy: string }[];

  permissions = {
    canViewNotes: false,
    canAddProject: false,
    canApproveProject: false,
  };

  currentUserRole: string;
  isApproved = false;

  isProjectApproved = false;
  filesChanged: boolean;
  isEdit: boolean;
  isAdd: boolean;
  isProjectRejected: boolean = false;
  allProjects: any;
  projectUniqueCode: string;
  extractedString: string;
  logobase64: string | null = null;
  // isLocked: boolean;
  selectedVertical : string;
  // tslint:disable-next-line: max-line-length
  constructor(
    private route: ActivatedRoute,
    private organizationService: OrganizationService,
    private projectService: ProjectService,
    private matDialog: MatDialog,
    // tslint:disable-next-line: max-line-length
    // tslint:disable-next-line: align
    // tslint:disable-next-line: max-line-length
    private customSearchService: CustomSearchService,
    private searchPageService: SearchPageService,
    private auth: AuthServiceService,
    private employeeService: EmployeeService,
    public sharedSkillService: SharedSkillService,
    private location: Location,
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
  ) {
    this.verticalOptions = this.verticalOptions.sort();
    this.uploads = new Array<AttachmentsModel>();
  }

  ngOnInit() {
    
    this.selectedVertical= history.state.selectedVertical;
        this.getprojectName();
    this.fetchAllOrganizations();

    this.currentUserRole = this.auth.getRole();
    if (this.currentUserRole != UserRoles.Viewer) {
      this.permissions.canViewNotes = true;
    }
    if (
      this.currentUserRole.includes(UserRoles.Admin) ||
      this.currentUserRole.includes(UserRoles.SuperAdmin)
    ) {
      this.permissions.canApproveProject = true;
    }
    this.route.queryParams.subscribe((params) => {

      if (params) {
        if (params.isView) {
          this.isView = JSON.parse(params.isView);
        }
        if (params.isApproved) {
          this.isApproved = JSON.parse(params.isApproved);
        }
      }
    });
    this.route.params.subscribe((res) => {
      this.searchTerm = res.searchTerm;
      if (res.id && res.id !== null && res.id !== undefined) {
        this.projectId = res.id;
        this.getProject(res.id);
        if (this.isView) {
          this.title = "Project Details";
        } else {
          this.title = "Edit Project";
          this.isEdit = true
          this.extractedString = res.speciality
        }
      } else {
        this.title = "Add Project";
        this.isAdd = true
        this.createFormControls();
      }
    });
    bsCustomFileInput.init();
    this.header.backgroundColor = true;
  }

  getprojectName() {

    this.projectService.getProjectName().subscribe(
      (response) => {
        this.projectnames = response;

      });
  }
  convertFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    })
  }
  async handleFileInput1(files: FileList, fileType: any) {
    if (files && files.item && files.item(0).size > 25000000) {
      this.showDialog("File size too large please select below 25MB");
      return;
    }
    this.filesChanged = true;
    const attachment = new AttachmentsModel();
    attachment.fileName = files.item(0).name;
    attachment.file = files.item(0);
    attachment.id = fileType;
    if (fileType == 3) {
      let processedFile = await Promise.resolve(this.convertFile(files[0]));
      this.logobase64 = processedFile.toString().split(",")[1];
    }
    if (this.uploads && this.uploads.length) {
      const fileTypeIndex = this.uploads.findIndex((ele) => ele.id == fileType);
      if (fileTypeIndex === -1) {
        this.uploads.push(attachment);
      } else {
        this.uploads[fileTypeIndex] = attachment;
      }
    } else {
      this.uploads.push(attachment);
    }
  }
  fetchAllOrganizations() {
    this.loading = true;
    this.organizationService.fetchOrganizationsList().subscribe(
      (res) => {
        this.loading = false;
        this.deliveryOrganizations = res;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  createFormControls() {
    if (!this.projectDetails) {
      this.projectDetails = new ProjectInformationHistory();
    }
   
    this.formData = new UntypedFormGroup({
      BDContact: new UntypedFormControl(
        this.projectDetails.bdContact ? this.projectDetails.bdContact : "",
        [Validators.required, Validators.pattern('^[a-zA-Z0-9.]+(?:[ ]+[a-zA-Z0-9.]+)*$')]
      ),
      Geography: new UntypedFormControl(
        this.projectDetails.geography ? this.projectDetails.geography : "",
        [Validators.required, Validators.pattern('^[a-zA-Z]+[a-zA-Z ]*$')]

      ),

      ProjectCode: new UntypedFormControl(
        this.projectDetails.projectCode ? this.projectDetails.projectCode : "",
        [Validators.pattern('^[a-zA-Z0-9.]+(?: [a-zA-Z0-9.]+)*$')]
      ),
      ProjectManager: new UntypedFormControl(
        this.projectDetails.projectManager
          ? this.projectDetails.projectManager
          : "",
          [Validators.required]
      ),
      ProjectName: new UntypedFormControl(
        this.projectDetails.projectName ? this.projectDetails.projectName : "",
        [Validators.required]
      ),
      RestrictedContent: new UntypedFormControl(
        this.projectDetails.restrictedContent
          ? this.projectDetails.restrictedContent
          : false
      ),
      Client: new UntypedFormControl(
        this.projectDetails.client ? this.projectDetails.client : "",
        Validators.pattern('^[a-zA-Z]+[a-zA-Z ]*$')
      ),
      ClientLogo: new UntypedFormControl(
        this.projectDetails.clientLogo ? this.projectDetails.clientLogo : ""
      ),
      Logo: new UntypedFormControl(""),
      Region: new UntypedFormControl(
        this.projectDetails.region ? this.projectDetails.region : "",
        [Validators.required, Validators.pattern('^[a-zA-Z]+[a-zA-Z ]*$')]

      ),
      Tags: new UntypedFormControl(
        this.projectDetails.tags ? this.projectDetails.tags : "",
        [Validators.required, Validators.pattern('^[a-zA-Z0-9.]+(?: [a-zA-Z0-9.]+)*$')]
      ),
      GeographyURL: new UntypedFormControl(
        this.projectDetails.geographyURL ? this.projectDetails.geographyURL : ""
      ),
      DownloadCount: new UntypedFormControl(
        this.projectDetails.FileDownloadCount
          ? this.projectDetails.FileDownloadCount
          : 0
      ),
      ViewCount: new UntypedFormControl(
        this.projectDetails.FileViewCount
          ? this.projectDetails.FileViewCount
          : 0
      ),
      ProjectStatus: new UntypedFormControl(
        this.projectDetails.projectStatus
          ? this.projectDetails.projectStatus
          : "Active"
      ),
      Status: new UntypedFormControl(
        this.projectDetails.status
          ? this.projectDetails.projectStatus
          : ProjectType.PendingDescription
      ),
      Vertical: new UntypedFormControl(
        this.projectDetails.vertical ? this.projectDetails.vertical : (this.selectedVertical == undefined
          ? "": this.selectedVertical
        ), Validators.required
      ),
      ProjectType: new UntypedFormControl(
        this.projectDetails.projectType ? this.projectDetails.projectType : ""
      ),
      ProjectSize: new UntypedFormControl(
        this.projectDetails.projectSize ? this.projectDetails.projectSize : ""
      ),
      DeliveryModel: new UntypedFormControl(
        this.projectDetails.deliveryModel
          ? this.projectDetails.deliveryModel
          : ""
      ),
      CreatedBy: new UntypedFormControl(
        this.projectDetails.createdBy ? this.projectDetails.createdBy : ""
      ),
      ContentType: new UntypedFormControl(
        this.projectDetails.contentType
          ? this.projectDetails.contentType
          : "Case Studies"
      ),
      // tslint:disable-next-line: max-line-length
      DeliveryOrganization: new UntypedFormControl(
        this.projectDetails.deliveryOrganization
          ? this.projectDetails.deliveryOrganization
          : this.auth.getOrganizationName(),
        Validators.required
      ),
      Version: new UntypedFormControl(
        this.projectDetails.version ? this.projectDetails.version : 1
      ),
      Id: new UntypedFormControl(
        this.projectDetails.id ? this.projectDetails.id : ""
      ),

      TCS: new UntypedFormControl(
        this.projectDetails.fileURL ? this.projectDetails.fileURL : "",
      ),
      BCS: new UntypedFormControl(
        this.projectDetails.bussinessCaseFileURL ? this.projectDetails.bussinessCaseFileURL : "",
      )
    });
    if (this.isView) {
      this.formData.disable();
    }
    if (this.currentUserRole != UserRoles.SuperAdmin) {

      this.formData.get("DeliveryOrganization").disable();
    }
    // this.formData.get('DeliveryOrganization').patchValue(this.auth.getOrganizationName());
  }

  goToHome() {
    this.router.navigate(["/Home"]);
  }
  goToSearch() {
    this.router.navigate(["/Home/KMSPortal"])
  }
  goToProjectContent() {
    this.router.navigate(["/Home/KMSPortal/Project Content"])
  }
  goToApproval() {
    this.router.navigate(["Home/KMSPortal/Pending Approvals"])
  }

  deliveryOrgChange() {
    this.projectDeliveryOrgID = this.formData.get("DeliveryOrganization").value;
    // this.getProjectsList();
  }
  goToCaseStudies(val: any) {
    if (val == "Case Studies") {
      val = "Case Studies"
    }
    if (val == "InformationTechnology") {
      val = "Information Technology"
    }
    this.router.navigate([`/Home/KMSPortal/${val}`])
  }

  getProject(projectId: string) {
    this.loading = true;
    // tslint:disable-next-line: max-line-length
    const projectObservable = this.isApproved
      ? this.projectService.getApprovedProject(projectId)
      : this.projectService.getProject(projectId);
    projectObservable.subscribe(
      (res) => {
        if (res) {
          this.projectDetails = this.isApproved ? res.fileInfo : res;
          this.projectUniqueCode =
            this.projectDetails.projectId || this.projectDetails.id;

          this.projectDeliveryOrgID = this.projectDetails.organizationId;

          if (
            this.projectDetails.status == ProjectType.PendingDescription &&
            this.permissions.canApproveProject
          ) {
            this.isPending = true;
          }
          if (this.projectDetails.notes && this.projectDetails.notes.length) {
            this.projectDetails.notes.forEach(
              (ele) => (ele.duration = this.getTimeSince(ele.createdOn))
            );
          }
          this.createFormControls();
          if (this.projectDetails.clientLogo) {
            // this.selectedLogoFile = this.projectDetails.clientLogo;
            var clientLogo = this.projectDetails.clientLogo.split("\\");
            const file = new AttachmentsModel();
            file.id = AttachmentTypes.clientLogo;
            file.fileName = clientLogo[clientLogo.length - 1];
          }
          if (this.projectDetails.fileURL) {
            var fileLinks = this.projectDetails.fileURL.split("\\");
            const file = new AttachmentsModel();
            file.id = AttachmentTypes.caseStudy;
            file.fileName = fileLinks[fileLinks.length - 1];
            Validators.required
            }
          if (this.projectDetails.bussinessCaseFileURL) {
            var fileLinks =
              this.projectDetails.bussinessCaseFileURL.split("\\");
            const file = new AttachmentsModel();
            file.id = AttachmentTypes.bussinessCaseStudy;
            file.fileName = fileLinks[fileLinks.length - 1];
            Validators.required
            }
          if (this.projectDetails.tags) {
            this.formData.patchValue({
              Tags: this.projectDetails.tags
                ? this.projectDetails.tags.join(", ")
                : "",
            });
          }

          } else {
          this.showDialog("Project details not found", true);
        }
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.showDialog(err.message, true);
      }
    );
  }
  getFilteredValues(event: any) {
    const specialCharsRegex = /[!#$%^&*_+\-=\[\]{};':"\\|,.<>\/?~]/; 
  
    if (event && specialCharsRegex.test(event)) {
      this.filteredValue = [];
    } else {
      this.employeeService.getEmployeesOnSearch(event).subscribe((res) => {
        this.filteredValue = res.data ? res.data.profiles : [];
      });
    }
  }
  getFilteredProjectValues(searchTerm: string) {
    
    this.filteredValues = this.projectnames.filter(topic =>
      topic.projectName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  
  }
  setCurrentEmployee(value: any) {
    this.employee = {}
    this.sharedSkillService.setEmployeeId(value);
    this.getEmployeeDetalis(value)
  }
  Onchange() {
    if (this.flag)
      this.a = this.formData.value
  }
  getEmployeeDetalis(empId?: string) {
    if (!empId)
      empId = this.sharedSkillService.getEmployeeId()

    if (empId) {
      this.loading = true;
      this.employeeService.getEmployeeDetails(empId).subscribe(res => {
        res.data.competencies?.forEach(c => {
          c.subCompetencies?.forEach(s => {
            s.certificates?.forEach(sc => {
              if (sc.status == 2) {
                sc.status = 1;
                sc.plannedDate = sc.expiryDate;
                sc.expiryDate = null;
              }
              return sc
            })
            return s
          })
          return c
        });
        this.employee = res.data;
        this.loading = false;
       }, error => {
        this.loading = false;
      });
    }
  }

  showDialog(message, navigateBack?, font?) {
    this.matDialog
      .open(InfoDialogComponent, {
        width: "280px",
        data: { message: message, class: font ? font : "text-danger" },
      })
      .afterClosed()
      .subscribe((res) => {
        if (navigateBack) {
          this.location.back();
          }
      });
  }

  viewFile(url) {
    const dialogRef = this.matDialog.open(ViewfileComponent, {
      width: "900px",
      height: "500px",
      panelClass: "view-file",
      data: { iFrameURL: url, Method: 'CaseStudies' },
    });
    dialogRef.afterClosed().subscribe((result) => {

    });
  }

  getTimeSince(date) {
    const seconds = Math.floor(
      (new Date().getTime() - new Date(date).getTime()) / 1000
    );
    let interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
      return interval + " years";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      return interval + " months";
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return interval + " days";
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return interval + " hours";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return interval + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }

  onSubmit(val: any) {
    this.loading = true;
    this.saveData();
  }

  cancel() {
    this.location.back();
  }

  addNote() {
    this.matDialog
      .open(CommentsDialogComponent, { data: { isNote: true } })
      .afterClosed()
      .toPromise()
      .then((response) => {
        if (response) {
        }
      });
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  showCommentsDialog(isApproved) {
    this.matDialog
      .open(CommentsDialogComponent, { data: { isApproved: isApproved } })
      .afterClosed()
      .toPromise()
      .then((response) => {
        if (response) {
          if (isApproved) {
            this.projectDetails.status = ProjectType.ApprovedDescription;
            this.projectDetails.approvedBy = this.auth.getEmailId();

            this.isProjectApproved = true;
          } else {
            this.projectDetails.status = ProjectType.RejectedDescription;
            this.isProjectRejected = true;
          }
          if (!this.projectDetails.notes) {
            this.projectDetails.notes = [];
          }
          const note = new Notes();
          note.createdOn = new Date();
          note.createdBy = this.auth.getEmailId();
          note.description = response;
          this.projectDetails.notes.push(note);
          this.saveData();
        }
      });
  }

  saveData() {
        this.flag = true;
        this.isProjectManger=false;
    this.loading = true;
    this.a = this.formData.getRawValue()
    this.a.caseStudyLogo = this.logobase64;
    if (this.a.caseStudyLogo === null) {
      this.a.caseStudyLogo = this.projectDetails.caseStudyLogo;
    }
    if (!(this.a.ProjectName && this.a.Vertical
      && this.a.ProjectManager && this.a.Geography
      && this.a.Region && this.a.BDContact
    )) {

      return;
    }
    
   
      if (this.a.ProjectName &&this.a.ProjectName.trim() !== this.a.ProjectName) {
     
        this.toastr.error("ProjectName Is Invalid Format");
        return;
      } 
      
      if (this.a.projectManager &&this.a.projectManager.trim() !== this.a.projectManager) {
        this.isProjectManger=true;
          return;
        } 
    
    let index = this.deliveryOrganizations.findIndex(
      (ele) => ele.id === this.formData.get("DeliveryOrganization").value
    );
    if (index === -1) {
      index = this.deliveryOrganizations.findIndex(

        (ele) => ele.name === this.formData.get("DeliveryOrganization").value
      );
    }
    let deliveryOrganization = this.deliveryOrganizations[index].name.replace(
      /\s/g,
      "_"
    );
    deliveryOrganization = deliveryOrganization.toLocaleUpperCase();

    // tslint:disable-next-line: max-line-length
    if (
      this.uploads &&
      this.uploads.length &&
      !this.isView &&
      this.filesChanged
    ) {
      const projectCode = this.formData.get("ProjectCode").value;
      for (let index = 0; index < this.uploads.length; index++) {
        switch (this.uploads[index].id) {
          case AttachmentTypes.bussinessCaseStudy:
            this.uploads[index].fileName =
              deliveryOrganization + "/" + projectCode + `_BUS.pptx`;
            break;
          case AttachmentTypes.caseStudy:
            this.uploads[index].fileName =
              deliveryOrganization + "/" + projectCode + `.pptx`;
            break;
          case AttachmentTypes.clientLogo:
            const logoExtension = this.uploads[index].file.name.substr(
              this.uploads[index].file.name.lastIndexOf(".") + 1
            );
            this.uploads[index].fileName =
              deliveryOrganization + "/" + projectCode + `.${logoExtension}`;
            break;
        }
      }

      this.projectService.saveFile(this.uploads).subscribe(
        (response) => {
          if (response) {
            this.addAttachmentToIndex(response);

          }
        },
        (error) => {
          this.loading = false;

          this.showDialog(error.error);
        }
      );
    } else {
      this.addAttachmentToIndex();
    }
  }

  addAttachmentToIndex(uploads?: UploadFileResponse) {
    this.loading = true;
    const fileName = this.formData.get("ProjectName").value + ".pptx";
    let tags = null;
    let projectInfo = this.formData.getRawValue();
    projectInfo.caseStudyLogo = this.logobase64;
    if (projectInfo.caseStudyLogo === null) {
      projectInfo.caseStudyLogo = this.projectDetails.caseStudyLogo;

    }
    if (uploads) {
      if (uploads.savedBussinessCasePPTPath) {
        projectInfo.BussinessCaseFileName =
          this.formData.get("ProjectName").value +
          "_BUS_" +
          this.formData.get("Client").value +
          ".pptx";
        projectInfo.BussinessCaseFileURL = uploads.savedBussinessCasePPTPath;
      }
      if (uploads.savedCaseStudyPPTPath) {
        projectInfo.FileName = fileName;
        projectInfo.FileURL = uploads.savedCaseStudyPPTPath;
      } else {
        projectInfo.FileName = this.projectDetails.fileName;
        projectInfo.FileURL = this.projectDetails.fileURL;
      }
      if (uploads.savedLogoPath) {
        projectInfo.sharepointId = uploads.savedLogoPath;
      }
    }
    projectInfo.UpdatedBy = this.auth.getEmailId();
    projectInfo.ApprovedBy = this.projectDetails.approvedBy;
    if (projectInfo.Tags && projectInfo.Tags.trim().length) {
      tags = projectInfo.Tags.split(",").map((item) => item.trim());
    }
    projectInfo.Tags = tags;
    if (this.projectDetails && this.projectDetails.FileDownloadCount) {
      projectInfo.FileDownloadCount = this.projectDetails.FileDownloadCount;
    }
    if (this.projectDetails && this.projectDetails.FileViewCount) {
      projectInfo.FileViewCount = this.projectDetails.FileViewCount;
    }

    // checking for update or add
    if (this.projectId) {
      // can optimize the below 3 LOC
      projectInfo.FileName = projectInfo.FileName
        ? projectInfo.FileName
        : this.projectDetails.fileName;
        projectInfo.sharepointId = projectInfo.sharepointId 
        ? projectInfo.sharepointId 
        : this.projectDetails.sharepointId;
      projectInfo.FileURL = projectInfo.FileURL
        ? projectInfo.FileURL
        : this.projectDetails.fileURL;
      projectInfo.BussinessCaseFileName = projectInfo.BussinessCaseFileName
        ? projectInfo.BussinessCaseFileName
        : this.projectDetails.bussinessCaseFileName;
      projectInfo.BussinessCaseFileURL = projectInfo.BussinessCaseFileURL
        ? projectInfo.BussinessCaseFileURL
        : this.projectDetails.bussinessCaseFileURL;
      // checking weather project is approved or not

      if (
        (this.currentUserRole === UserRoles.Admin ||
          this.currentUserRole === UserRoles.SuperAdmin) &&
        !this.isView
      ) {
        this.isApproved = true;
      }
      if (this.isApproved) {
        projectInfo.Version = this.projectDetails.version
          ? ++this.projectDetails.version
          : 1;
        projectInfo.ProjectId = this.projectUniqueCode;
        // this.projectDetails.projectId ? this.projectDetails.projectId : this.generateProjectId();
        projectInfo.OrganizationId = this.formData.getRawValue()
          .DeliveryOrganization
          ? this.formData.getRawValue().DeliveryOrganization
          : this.auth.getOrganizationId();

        if (
          this.currentUserRole === UserRoles.Admin ||
          this.currentUserRole === UserRoles.SuperAdmin
        ) {
          projectInfo.Status = ProjectType.ApprovedDescription;
        } else {
          projectInfo.IsLocked = true;
          projectInfo.Status = ProjectType.PendingDescription;
        }
        this.addProject(projectInfo);
      } else {
        projectInfo["Id"] = this.projectId;
        projectInfo.Status = this.isProjectRejected
          ? ProjectType.RejectedDescription
          : this.projectDetails.status;
        projectInfo.Notes = this.projectDetails.notes;
        projectInfo.IsLocked = this.projectDetails.isLocked;
        projectInfo.OrganizationId = this.projectDetails.organizationId;
        projectInfo.ProjectId = this.projectUniqueCode;
        if (this.isProjectApproved) {
          this.addProjectToApprovedList(projectInfo);
        } else {
          this.updateProject(projectInfo);
        }
      }
    } else {
      projectInfo.Version = 1;
      // tslint:disable-next-line: max-line-length
      projectInfo.OrganizationId = this.auth.getOrganizationId();
      // tslint:disable-next-line: triple-equals
      // tslint:disable-next-line: max-line-length
      if (
        this.currentUserRole === UserRoles.SuperAdmin ||
        (this.currentUserRole === UserRoles.Admin &&
          this.formData.getRawValue().DeliveryOrganization ==
          this.auth.getOrganizationName())
      ) {
        projectInfo.ApprovedBy = this.auth.getEmailId();
        projectInfo.Status = ProjectType.ApprovedDescription;
        this.createApprovedProject(projectInfo);
      } else {
        this.addProject(projectInfo);
      }
    }
  }

  addProjectToApprovedList(projectInfo) {
    if (projectInfo.IsLocked) {
      projectInfo.IsLocked = false;
      projectInfo.version = this.projectDetails.version + 1;
      this.updateApprovedProject(projectInfo, true);
    } else {
      this.createApprovedProject(projectInfo);
    }
  }

  createApprovedProject(projectInfo) {
    this.loading = true;
    projectInfo.version = 1;
    projectInfo.CreatedBy = this.auth.getEmailId();
    const projectId = projectInfo.Id;
    projectInfo.Id = null;
    this.projectService.insertProjectToApprovedList(projectInfo).subscribe(
      (response) => {
        projectInfo.Id = projectId;
        projectInfo.ProjectId = response.projectId;
        // tslint:disable-next-line: max-line-length
        if (
          (this.currentUserRole === UserRoles.SuperAdmin ||
            (this.currentUserRole === UserRoles.Admin &&
              this.formData.getRawValue().DeliveryOrganization ===
              this.auth.getOrganizationId())) &&
          !this.isView
        ) {
          this.addProject(projectInfo, true);
        } else {
          projectInfo.CreatedBy = this.projectDetails.createdBy;
          this.updateProject(projectInfo, true);
        }

        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.showDialog(error.error, false);
      }
    );
  }

  generateProjectId() {
    return `xxxxxxx${Math.round(Math.random())}xxxxxxxx`.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  addProject(projectInfo, showApprovedMessage?) {
    this.loading = true;
    projectInfo.CreatedBy = this.auth.getEmailId();
    projectInfo.UpdatedBy = this.auth.getEmailId();
    projectInfo.Tags = projectInfo.Tags ?? [];
    this.projectService.insertProject(projectInfo).subscribe(
      (res) => {
        this.loading = false;
        if (this.isApproved) {
          const projectData = this.projectDetails as any as ProjectInformation;
          projectData.isLocked = true;
          projectData.version--;
          projectInfo.id = projectInfo.projectId = this.projectUniqueCode;
          if (
            this.currentUserRole.includes(UserRoles.Admin) ||
            this.currentUserRole.includes(UserRoles.SuperAdmin)
          ) {
            // projectInfo
            this.updateApprovedProject(projectData, false);
          } else {
            this.updateApprovedProject(projectInfo, false);
            // projectData
          }
        } else {
          this.toastr.success(
            showApprovedMessage
              ? "Project Submitted Successfully"
              : "Project Added to Approved List",
          );
          this.location.back();
        }
      },
      (err) => {
        this.loading = false;
        this.showDialog(err.error);
      }
    );
  }

  updateApprovedProject(projectInfo, isApproved?) {
    this.loading = true;
    projectInfo.updatedBy = this.auth.getEmailId();
    projectInfo.Status = ProjectType.ApprovedDescription;
    projectInfo.IsActive = true;
    this.projectService.updateApprovedProject(projectInfo).subscribe(
      (response) => {
        this.loading = false;
        if (
          isApproved &&
          (this.currentUserRole.includes(UserRoles.Admin) ||
            this.currentUserRole.includes(UserRoles.SuperAdmin))
        ) {
          this.updateProject(projectInfo, true);
        } else {
          // this.showDialog('Changes Submitted', true, 'text-success');
          let message = "";
          if (
            this.currentUserRole.includes(UserRoles.Admin) ||
            this.currentUserRole.includes(UserRoles.SuperAdmin)
          ) {

            message = "Project submitted with new changes";
          }
          this.toastr.success(message);
          this.loading = false;
          this.cancel();
        }
        // tslint:disable-next-line: no-shadowed-variable
      },
      (error) => {
        this.toastr.error(error.error);
        this.loading = false;
      }
    );
  }

  updateProject(projectInfo, isApproved?) {
    projectInfo.updatedBy = this.auth.getEmailId();
    this.projectService.updateProject(projectInfo).subscribe(
      (res) => {
        this.loading = false;
        if (isApproved) {

          this.toastr.success("Project Approved");
        }
        this.cancel();
        if (!isApproved) {

          this.toastr.error("Project Rejected");
        }
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  handleReaderLoaded(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
  }

  getFile(index) {
    if (
      this.uploads &&
      this.uploads.length &&
      this.uploads.find((ele) => ele.id === index)
    ) {
      const file = this.uploads.find((ele) => ele.id === index);
      return file ? file.fileName : "Choose file";
    } else if (
      index === this.attachmentTypes.bussinessCaseStudy &&
      this.projectDetails.bussinessCaseFileURL
    ) {
      return this.projectDetails.projectCode + ".pptx";
    } else if (
      index === this.attachmentTypes.caseStudy &&
      this.projectDetails.fileURL
    ) {
      return this.projectDetails.projectCode + ".pptx";
    } else if (
      index === this.attachmentTypes.clientLogo &&
      this.projectDetails.sharepointId
    ) {
      return this.projectDetails.projectName + ".png";
    }
    return "Choose file";
  }

  handleFileInput(files: FileList, fileType) {
    // size 10,00,000 = 1MB
    if (files && files.item && files.item(0).size > 1000000) {
      this.showDialog("File size too large please select below 1MB");
      return;
    }
    this.filesChanged = true;
    const attachment = new AttachmentsModel();
    attachment.fileName = files.item(0).name;
    attachment.file = files.item(0);
    attachment.id = fileType;
    if (this.uploads && this.uploads.length) {
      const fileTypeIndex = this.uploads.findIndex((ele) => ele.id == fileType);
      if (fileTypeIndex === -1) {
        this.uploads.push(attachment);
      } else {
        this.uploads[fileTypeIndex] = attachment;
      }
    } else {
      this.uploads.push(attachment);
    }
  }

  

  changeClientLogo(files: FileList) {
    this.selectedLogoFileName = null;
    this.selectedLogoFile = files.item(0);
  }

  dismissSidebar() {
    $("#sidebar").removeClass("active");
    $("#sidebar_r").removeClass("active");
    $(".overlay").removeClass("active");
  }
}
